import http from 'plugins/axios';

export default {
  addOne(data) {
    return http.post({
      url: '/la/admin/partner/nodes/add',
      data,
    });
  },

  getUrlList(data) {
    return http.get({
      url: `/la/admin/partner/nodes/list`,
      data
    })
  },
  delOne(id) {
    return http.post({
      url: `/la/admin/partner/nodes/del?id=${id}`,
    });
  },
  updateUrl(data) {
    return http.post({
      url: '/la/admin/partner/nodes/update',
      data,
    });
  },
};
